import { createRoot } from "react-dom/client";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "./App";
import "./index.css";



// Debug hooks (remove later)
window.addEventListener("error", (e) => {
  console.log("[window.error]", e.message, e.error?.stack);
});
window.addEventListener("unhandledrejection", (e) => {
  console.log("[unhandledrejection]", e.reason);
});
console.log("VITE_BFF_BASE =", import.meta.env.VITE_BFF_BASE);


// Optional: if someone lands on .../index.html, normalize to hash root
if (location.pathname.endsWith("/index.html")) {
  history.replaceState(null, "", location.pathname.replace(/\/index\.html$/, "/") + location.search + "#/");
}

createRoot(document.getElementById("root")!).render(
  <HashRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </HashRouter>
);
